import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import commonEn from "./locales/en/common.json";
import commonHi from "./locales/hi/common.json";
import commonBn from "./locales/bn/common.json";
import commonTe from "./locales/te/common.json";
import commonTa from "./locales/ta/common.json";
import commonMr from "./locales/mr/common.json";
import commonGu from "./locales/gu/common.json";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            common: commonEn,
        },

        hi: {
            common: commonHi,
        },
        bn:{
            common:commonBn,
        },
        te:{
            common:commonTe,
        },
        ta:{
            common:commonTa,
        },
        mr:{
            common:commonMr,
        },
        gu:{
            common:commonGu,
        },
    },

    lng: "en",

    fallbackLng: "en",

    ns: ["common"],
    
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;